module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/district/district.component.css
// module id = ./src/app/Pages/manage/district/district.component.css
// module chunks = main